(function card($, Drupal, once) {
  Drupal.behaviors.rutherford_card = {
    attach(context) {
      $(once('rutherford-card', '[data-card]', context))
        .each(function eachCard() {
          // https://inclusive-components.design/cards/

          const $link = $(this)
            .find('a')
            .first();

          if ($link.length === 0 || $(this).data().cardClickable === false) {
            return;
          }

          $(this).css('cursor', 'pointer');

          let down;
          let up;

          $(this).mousedown(() => {
            down = +new Date();
          });

          $(this).mouseup(e => {
            // Bail if this was a middle or secondary mouse button event.
            if (e.which !== 1) return;

            up = +new Date();
            if (up - down < 200) {
              // Use the time difference between mouse down and mouse up to
              // guess whether the user is clicking, or trying to select text.
              // Only redirect if it looks like a click not text selection.
              window.location.href = $link.attr('href');
            }
          });

          // If we are inside a carousel we can't be as smart as above as
          // Swiper.js blocks mousedown events :(
          if ($(this).parents('[data-carousel]').length > 0) {
            $(this).click(() => {
              window.location.href = $link.attr('href');
            });
          }
        });
    },
  };
})(jQuery, Drupal, once);
